import './styles.scss';

import { ListGroup, ListGroupItem } from 'react-bootstrap';

import { FilterOption } from '@/models/gen/graphql';
import { HTMLAttributes } from 'react';
import { getClasses } from '@/utils';

type CategoriesTabsProps = Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> & {
  tabs: FilterOption[];
  selectedRoleId: string;
  onSelect: (roleId: string) => void;
};

export const CategoriesTabs = ({ tabs, selectedRoleId, onSelect, className, ...props }: CategoriesTabsProps) => {
  return (
    <div {...props} className={getClasses('CategoriesTabs', className)}>
      <ListGroup horizontal>
        {tabs.map((tab) => (
          <ListGroupItem key={tab.id} action active={tab.id === selectedRoleId} onClick={() => onSelect(tab.id)}>
            {tab.displayName}
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};
